import { Grid, Card, CardContent, CardHeader, Typography, Box } from "@mui/material";
import { useState, useEffect } from "react";
import { useCurrentHousehold } from "../contexts/AuthProvider";
import { IngredientsCategory, plannedMeals, shoppingList } from "../data";
import { addDay } from "../dates";
import { buildIngredientString } from "../utils/shoppingLists";

export default function UpcomingIngredients() {
    const currentHousehold = useCurrentHousehold();
    const [ingredients, setIngredients] = useState<IngredientsCategory[]>();
    const today = new Date();

    useEffect(() => {
        if (!currentHousehold) return;

        plannedMeals(currentHousehold.id, today, addDay(today, 7)).then(plannedMeals =>
            shoppingList(plannedMeals.map(r => ({ recipe_id: r.recipe.id, servings: r.servings }))).then(list =>
                setIngredients(list.list.filter(list => list.items.length > 0))
            )
        );
    }, [currentHousehold, setIngredients]);

    return (
        <Box flexGrow={1}>
            <Typography variant="h5">Kommande ingredienser</Typography>
            <Box paddingTop="15px">
                {ingredients && ingredients.length === 0 && (
                    <Typography variant="body1">Inga ingredienser planerade.</Typography>
                )}

                {!ingredients && <Typography variant="body1">Läser in...</Typography>}

                {ingredients && (
                    <Grid container spacing={2}>
                        {ingredients.map((category, idx) => (
                            <Grid item key={idx} xs={12} sm={6} md={4} lg={3}>
                                <Card variant="outlined">
                                    <CardHeader
                                        title={category.name ?? "Övrigt"}
                                        sx={theme => ({
                                            backgroundColor: theme.palette.secondary.main,
                                            color: theme.palette.secondary.contrastText,
                                        })}
                                    />
                                    <CardContent>
                                        {category.items.map((ingredient, i) => (
                                            <Typography key={i} variant="body2">
                                                {buildIngredientString(
                                                    ingredient.name,
                                                    ingredient.quantity,
                                                    ingredient.unit
                                                )}
                                            </Typography>
                                        ))}
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Box>
        </Box>
    );
}
